<template>
  <div class="flex flex-col items-center justify-center w-full min-h-screen">
    <slot></slot>
  </div>
</template>
